export const DELAY_BEFORE_UPDATE = 6000;
export const INTERVAL_BEFORE_CHECK_FOR_AN_UPDATE = 2000;
